import luxinLanguages from "@/statics/language.js";

luxinLanguages.en = {
  title: "English",
  short: "en",
  isRTL: false,
  NODE2_INPUT1_NAME: "Input 1",
  NODE2_INPUT2_NAME: "Input 2",
  NODE2_OUTPUT1_NAME: "Output 1",
  NODE2_OUTPUT2_NAME: "Output 2",
  NODE3_INPUT1_NAME: "Input 1",
  NODE3_OUTPUT1_NAME: "Output 1",
  NODE4_INPUT1_NAME: "Input 1",
  NODE4_INPUT2_NAME: "Input 2",
  NODE4_OUTPUT1_NAME: "Output 1",
  NODE5_INPUT1_NAME: "Input 1",
  NODE5_OUTPUT1_NAME: "Output 1",
  NODE6_INPUT1_NAME: "Temperature",
  NODE6_INPUT2_NAME: "Humidity",
  Hub_Owner: "Admin",
  Hub_User: "User",
  Common_internetError: "Please check your internet connection.",
  Devices_addNewDevice: "Add Device",
  BottomNav_dashboard: "Dashboard",
  BottomNav_devices: "Devices",
  BottomNav_settings: "Settings",
  Devices_Hub_Priviledge: "Access Level",
  Devices_Hub_IP: "IP Address",
  Devices_Hub_accessOwner: "Admin",
  Devices_Hub_accessNormal: "User",
  Devices_noHubs: "Hub not found!",
  Devices_noNodes: "No devices found for this Hub!",
  Device_serachPlaceHolder: "Search...",
  Devices_searchNotFound: "No matche found",
  LanguageSelect_selectLanguage: "Select Language",
  LanguageSelect_submitButton: "Select",
  LoginRegister_title: "Sign Up",
  LoginRegister_text: "Please enter your mobile number.",
  LoginRegister_button: "Send Code",
  LoginRegister_placeHolder: "Mobile Number",
  LoginRegister_back: "Back",
  LoginRegister_inputError: "Invalid Mobile Number",
  LoginRegister_serverResponseFail: "Something's wrong! Check your number and try again.",
  LoginConfirmationCode_title: "Confirmation Code",
  LoginConfirmationCode_text: "Please enter your confirmation code.",
  LoginConfirmationCode_failMessage: "That's not the code we sent you!",
  LoginConfirmationCode_retry: "Resend",
  LuxinIntro_Next: "Next",
  LuxinIntro_Finish: "Let's Go",
  IntroSlide1_title: "Welcome to Luxin",
  IntroSlide1_text: "You can easily access your Luxin smart home from here.",
  IntroSlide2_title: "Internet of Things",
  IntroSlide2_text: "You can monitor and control your home from any where, at any time!",
  IntroSlide3_title: "Luxin Hub",
  IntroSlide3_text: "You need to connect to you smart home's central controller first.",
  IntroSlide4_title: "Connecting to Hub",
  IntroSlide4_text: "If someone else has already setup your Hub, ask them for access.",
  AddDevice_title: "Add Device",
  AddDevice_text: "If you are not the first one to setup this project, slect second option.",
  AddDevice_button: "Add New Device",
  AddDevice_button2: "Access Existing Device",
  AddNewDevice_title: "Add New Device",
  AddNewDevice_text: "We need the QR code printed on your device.",
  AddNewDevice_button: "Camera Scan",
  AddNewDevice_button2: "Select from Library",
  AddNewDeviceScanQR_title: "Camera Scan Mode",
  AddNewDeviceScanQR_text: "Point the camera at devices QR code. You need to grant camera permission for this app.",
  AddNewDeviceScanQR_button: "Scan Again",
  AddNewDeviceScanQR_loading: "Please Wait...",
  AddNewDeviceScanQR_error: "Invalid QR Code!",
  AddNewDeviceScanQR_NotAllowedError: "Error! Please grant camera permission for this app.",
  AddNewDeviceScanQR_NotFoundError: "Error! Camera not found.",
  AddNewDeviceScanQR_NotSupportedError: "Error! Camera not supported.",
  AddNewDeviceScanQR_NotReadableError: "Error! Camera not readable.",
  AddNewDeviceScanQR_OverconstrainedError: "Error! Constraints not met.",
  AddNewDeviceScanQR_StreamApiNotSupportedError: "Error! Stream not supported.",
  AddNewDeviceUploadQR_button: "Select Photo",
  AddNewDeviceUploadQR_title: "Select Photo of QR code",
  AddNewDeviceUploadQR_text: "Please select a photo containing a Luxin QR code.",
  AddNewDeviceUploadQR_alert: "This photo does not contain a valid Luxin QR Code. Please try again.",
  AddDeviceNoHub_title: "Warning",
  AddDeviceNoHub_text: "You don't have a Luxin Hub in your app. Please connect to a Hub.",
  AddNewDeviceDuplicated_title: "Oops!",
  AddNewDeviceDuplicated_text: "You've already added this device.",
  AddHub_title: "Add Hub",
  AddHub_text: "This is a 'Luxin Hub'. To continue, hit 'Next'",
  AddHub_button: "Next",
  AddHubTurnOn_title: "Turn it ON",
  AddHubTurnOn_text: "Plug it to a power source and turn it ON using the power button.",
  AddHubTurnOn_button: "Next",
  AddHubLedCheck_title: "Hub's LED Status",
  AddHubLedCheck_text: "Is the Hub's LED glowing red and doesn't blink?",
  AddHubLedCheck_button: "Yes",
  AddHubLedCheck_button2: "No",
  AddHubLedError_title: "Oops!",
  AddHubLedError_text: "This Hub already has an ADMIN. Ask the admin to add you as a USER. Or you can reset this Hub as a new one.",
  AddHubLedError_button: "Reset Hub",
  AddHubLedError_Cancel: "Back",
  AddHubReset_title: "Reset Hub",
  AddHubReset_text:
    "Push the reset button located behind the small hole on the back. To change the ADMIN, hold the button till Hub's LED blinks Red/Blue and release. For FACTORY RESET, don't release till the LED blinks faster.",
  AddHubReset_button: "Next",
  AddHubSecurity_title: "Security Options",
  AddHubSecurity_text: "You can use Two-Factor authentication by setting a password on your Hub to have maximum security.",
  AddHubSecurity_button: "Choose Password",
  AddHubSecurity_button2: "I don't need a password!",
  AddHubSetPassword_title: "Two-Factor Auth.",
  AddHubSetPassword_placeHolder: "Password",
  AddHubSetPassword_placeHolder2: "Confirm Password",
  AddHubSetPassword_text: "This is not your account password. It's this Hub's password!.",
  AddHubSetPassword_button: "Next",
  AddHubSetPassword_alert_passwordEmpty: "Please enter a password!",
  AddHubSetPassword_alert_passwordNotMatch: "Password confirmation doesn't match password!",
  AddHubNameColor_title: "Customize Hub",
  AddHubNameColor_text: "Please select a name and a color for your Hub.",
  AddHubNameColor_placeHolder: "Name (Home, Office, ...)",
  AddHubNameColor_button: "Next",
  AddHubNameColor_alert_nameEmpty: "Please enter a name for your Hub",
  AddHubConnectWifi_title: "Connect to Hub",
  AddHubConnectWifi_text: "Please go to your phone's Wi-Fi settings and connect to the following network. Then return to this App and select 'Connect to Hub'.",
  AddHubConnectWifi_button: "Connect to Hub",
  AddHubNotFound_Cancel: "Cancel",
  AddHubNotFound_title: "Hub Connection Error!",
  AddHubNotFound_text: "Unfortunately there was a problem connecting to your Hub. Please make sure that you are connected to Hub's Wi-Fi network and then try again.",
  AddHubNotFound_button: "Try Again",
  AddHubSuccess_title: "Success",
  AddHubSuccess_text: "Your Luxin Hub has successfully been added to your app. You can view and edit your Hub's settings in 'Devices' tab.",
  AddHubSuccess_button: "Finish",
  AddNode2_title: "Lighting Double Switch",
  AddNode2_text: "You've scanned a Lighting Double Switch. Hit next to add this device to your smart home.",
  AddNode2_button: "Next",
  AddNode3_title: "Lighting Single Switch",
  AddNode3_text: "You've scanned a Lighting Single Switch. Hit next to add this device to your smart home.",
  AddNode3_button: "Next",
  AddNode4_title: "Lighting Multiway Switch",
  AddNode4_text: "You've scanned a Lighting Multiway Switch. Hit next to add this device to your smart home.",
  AddNode4_button: "Next",
  AddNode5_title: "General Purpose Switch",
  AddNode5_text: "You've scanned a General Purpose Switch. Hit next to add this device to your smart home.",
  AddNode5_button: "Next",
  AddNode6_title: "Temperature-Humidity Sensor",
  AddNode6_text: "You've scanned a Temperature-Humidity Sensor. Hit next to add this device to your smart home.",
  AddNode6_button: "Next",
  AddNodeSelectHub_title: "Select Hub",
  AddNodeSelectHub_text: "Please select the Hub to be paired with this device.",
  AddNodeNameColor_title: "Customize Device",
  AddNodeNameColor_text: "Please select a name and a color for this device.",
  AddNodeNameColor_button: "Add",
  AddNodeNameColor_placeHolder: "Device Name",
  AddNodeNameColor_alert_nameEmpty: "Please enter a name for this device",
  AddNodeNameColor_alert_duplicateNode: "This device is already added!",
  AddNodeSuccess_title: "Success",
  AddNodeSuccess_text: "This device is successfully added to your smart home. To start using it, pair it with your Hub in 'Devices' tab.",
  AddNodeSuccess_button: "Finish",
  AddNodeHubNotFound_title: "Hub Connection Error!",
  AddNodeHubNotFound_text: "Unfortunately there was a problem connecting to your Hub. Please make sure that you are connected to Hub's Wi-Fi network and then try again.",
  AddNodeHubNotFound_button: "Try Again",
  PairNode_title: "Pair Device",
  PairNode_text: "You should 'Pair' this device with a Hub. Before your hit the 'Pair' button, make sure your Hub is turned on and connected to your app.",
  PairNode_button: "Pair",
  PairNode_button2: "Delete Device",
  PairNodeSuccess_title: "Success",
  PairNodeSuccess_text: "This device is successfully paired with your Hub and is ready for use.",
  PairNodeSuccess_button: "Finish",
  PairNodeHubNotResponding_title: "Hub Connection Error!",
  PairNodeHubNotResponding_text: "Unfortunately there was a problem connecting to your Hub. Please make sure that you are connected to Hub's Wi-Fi network and then try again.",
  PairNodeHubNotResponding_button: "Try Again",
  PairNodeNodeNotResponding_title: "Device Connection Error!",
  PairNodeNodeNotResponding_text: "Your Hub is unable to communicate with this device. Please make sure the device is powered on.",
  PairNodeNodeNotResponding_button: "Try Again",
  Node2Settings_title1: "Customize Device",
  Node2Settings_title2: "Device Information",
  Node2Settings_title3: "Default Modes",
  Node2Settings_button: "Save Changes",
  Node2Settings_button2: "Delete Device",
  Node2Settings_text1: "Name",
  Node2Settings_default1: "Same Normally Open",
  Node2Settings_default2: "Same Normally Closed",
  Node2Settings_default3: "Cross Normally Open",
  Node2Settings_default4: "Cross Normally Closed",
  Node3Settings_default1: "Normally Open",
  Node3Settings_default2: "Normally Closed",
  Node4Settings_default1: "Multiway Inputs",
  Node2Settings_deviceStatus: "Status",
  Node2SettingsHubNotResponding_title: "Hub Connection Error!",
  Node2SettingsHubNotResponding_text: "Unfortunately there was a problem connecting to your Hub. Please make sure that you are connected to Hub's Wi-Fi network and then try again.",
  Node2SettingsHubNotResponding_button: "Back",
  Node2SettingsSuccess_title: "Success",
  Node2SettingsSuccess_text: "The new settings are successfully saved on your device.",
  Node2SettingsSuccess_button: "Back",
  Node2SettingsNodeNotResponding_title: "Device Connection Error!",
  Node2SettingsNodeNotResponding_text: "Your Hub is unable to communicate with this device. Please make sure the device is powered on.",
  Node2SettingsNodeNotResponding_button: "Back",
  Node2Settings_alert: "Please enter a name for this device.",
  Node2Settings_timerTimeout: "ُTimer Timeout(s)",
  DeleteDevice_title: "Warning!",
  DeleteDevice_text: "You are about to delete this device. To add it again, you need to scan the QR code on it's label. Are you sure?",
  DeleteDevice_button: "Yes",
  DeleteDevice_button2: "No",
  DeleteDeviceSuccess_title: "Success",
  DeleteDeviceSuccess_text: "The device is successfully deleted from your smart home.",
  DeleteDeviceSuccess_button: "Back",
  RelaySSR2ASettings_title1: "Output",
  RelaySSR2ASettings_text1: "Output State",
  RelaySSR2ASettings_switchState_On: "ON",
  RelaySSR2ASettings_switchState_Off: "OFF",
  RelaySSR2ASettings_title2: "Output Settings",
  RelaySSR2ASettings_text2: "Output Type",
  RelaySSR2ASettings_text3: "Name",
  RelaySSR2ASettings_text4: "Initial State",
  RelaySSR2ASettings_button: "Save Changes",
  RelaySSR2ASettings_initState1: "ON",
  RelaySSR2ASettings_initState2: "OFF",
  RelaySSR2ASettings_outputType1: "Lighting",
  RelaySSR2ASettings_outputType2: "Watering",
  RelaySSR2ASettings_outputType3: "Cooler",
  RelaySSR2ASettings_outputType4: "Heater",
  RelaySSR2ASettings_outputType5: "Door",
  RelaySSR2ASettings_alert: "Please enter a name for this output.",
  ZeroContactSettings_title1: "Input",
  ZeroContactSettings_text1: "Input State",
  ZeroContactSettings_title2: "Input Settings",
  ZeroContactSettings_text2: "Input Type",
  ZeroContactSettings_inputType1: "Normal Switch",
  ZeroContactSettings_inputType2: "Push Button",
  ZeroContactSettings_inputType3: "Smoke Detector",
  ZeroContactSettings_inputType4: "Presence Detector",
  ZeroContactSettings_text3: "Input Name",
  ZeroContactSettings_text4: "Direction",
  ZeroContactSettings_alert: "Please enter a name for this input.",
  ZeroContactSettings_button: "Save Changes",
  ZeroContactSettings_text5: "Impact",
  HubSettings_title1: "Customize Device",
  HubSettings_text1: "Name",
  HubSettings_title2: "Manage Hub",
  HubSettings_button: "Save Changes",
  HubSettings_button2: "Delete Hub",
  HubSettings_alert: "Please enter a name for this Hub.",
  HubSettings_title3: "Status",
  HubSettings_button3: "Update Firmware",
  HubSettings_button4: "Manage Users",
  HubSettings_button5: "Manage Wi-Fi Network",
  DeleteHub_title: "Delete Hub",
  DeleteHub_text:
    "You are about to delete this Hub. If you proceed, all Devices connected to this hub are also deleted from your app. You will need to use this Hub's UUID and its password to connect to it again. Are you sure?",
  DeleteHub_button: "Yes",
  DeleteHub_button2: "No",
  OTA_title: "Firmware Update",
  OTA_text:
    "This will update you Hub's firmware to the latest version. Make sure that your Hub is connected to internet and a stable power supply. DO NOT TURN OFF YOUR HUB IN THE PROCCESS. Are you sure you want to continue?",
  OTA_button: "Yes",
  OTA_button2: "No",
  OtaSuccess_title: "Success",
  OtaSuccess_text: "Your Hub's firmware is being updated. Please do not turn off the hub and wait for hub's LED to stop blinking fast. Then restart it.",
  OtaSuccess_button: "Done",
  HubNetworkSettings_title: "Hub Network Settings",
  HubNetworkSettings_text1: "Network Type",
  HubNetworkSettings_text2: "WiFi Name (SSID)",
  HubNetworkSettings_text3: "Wi-Fi Password",
  HubNetworkSettings_alert: "Your request could not be completed. Please try again.",
  HubNetworkSettings_button: "Save Changes",
  HubNetworkSettings_alert2: "Please enter network name.",
  HubNetworkSettingsSuccess_title: "Success",
  HubNetworkSettingsSuccess_text: "Hub's Wi-Fi network changed successfully. Please change your phone's WiFi setting and connect to the same network as Hub's.",
  HubNetworkSettingsSuccess_button: "Done",
  HubNetworkSettings_text4: "ُStatic IP",
  HubNetworkSettings_text5: "Port",
  HubStaticIp_title: "Set static IP",
  HubStaticIp_button: "Save new IP",
  HubStaticIp_button2: "Disable static IP",
  HubStaticIp_alert: "The new Ip was set successfully",
  HubStaticIp_alert2: "Static Ip disabled",
  HubUserSettings_title: "َUsers",
  HubUserSettings_button: "Add New User",
  EditUser_title1: "Edit User",
  EditUser_text1: "Mobile Numebr",
  EditUser_text2: "Access Level",
  EditUser_text3: "User Name",
  EditUser_button1: "Delete User",
  EditUser_button2: "Save Changes",
  EditUser_alert: "Please enter a name for this user.",
  EditUser_ownerText: "Admin",
  EditUser_normalText: "User",
  AddNewUser_title: "Add New User",
  AddNewUser_text: "To add the new user, please enter mobile number and name of the new user.",
  AddNewUser_placeHolder: "Mobile Number",
  AddNewUser_placeHolder2: "Name",
  AddNewUser_button: "Add New User",
  AddNewUser_alert1: "Please enter the mobile number of new user.",
  AddNewUser_alert2: "Please enter the name of new user.",
  AddNewUser_alert3: "User already registered.",
  AddNewUser_serverResponseFail: "Request failed. Please check mobile number and try again.",
  NewUserCredentials_title: "New User",
  NewUserCredentials_text: "The new user is successfully added to your Hub. They can log into your Hub by entering these credentials. Please save this page and send it to the new user.",
  NewUserCredentials_button: "Finish",
  DeleteUser_title: "Delete User",
  DeleteUser_text: "Are you sure you want to delete this user from your Hub?",
  DeleteUser_button: "Yes",
  DeleteUser_button2: "No",
  HubLogin_title: "Connect to Device",
  HubLogin_text: "Please make sure you are in the same Wi-Fi network as Device's and enter your login credentials provided by this Device's Admin.",
  HubLogin_placeHolder: "Device UUID",
  HubLogin_placeHolder2: "Password",
  HubLogin_button: "Connect",
  HubLogin_alert1: "Please enter Device UUID.",
  HubLogin_alert2: "Please enter your password.",
  HubLogin_alert3: "You are already connected to this Device.",
  HubLoginSuccess_title: "Success",
  HubLoginSuccess_text: "You are now connected to this Device.",
  HubLoginSuccess_button: "Finish",
  HubLoginNotFound_title: "Login Failed",
  HubLoginNotFound_text: "The app is unable to communicate with this Device. Please make sure you are connected to the same Wi-Fi network and check UUID field.",
  HubLoginNotFound_button: "Try Again",
  HubLoginError_title: "Login Failed",
  HubLoginError_text: "Your password was rejected by this Device. Please try again or contact the Device's Admin.",
  HubLoginError_button: "Try Again",
  MainMenu_title: "Main Menu",
  MainMenu_button1: "Language Select",
  MainMenu_button2: "Log Out",
  LogOut_title: "Log Out",
  LogOut_text: "Are you sure you want to log out of system?",
  LogOut_button: "Yes",
  LogOut_button2: "No",
  TemperatureSensorSettings_title1: "Input",
  TemperatureSensorSettings_text1: "Temperature",
  TemperatureSensorSettings_title2: "Input Settings",
  TemperatureSensorSettings_text3: "Input Name",
  TemperatureSensorSettings_button: "Save Changes",
  HumiditySensorSettings_title1: "Input",
  HumiditySensorSettings_text1: "Humidity",
  HumiditySensorSettings_title2: "Input Settings",
  HumiditySensorSettings_text3: "Input Name",
  HumiditySensorSettings_button: "Save Changes",
  DashBoard_noWidgets: "No Widgets Found.",
  Dashboard_editWidgets: "Edit",
  DashBoard_addWidget: "Add Widget",
  Dashboard_doneEditing: "Save",
  LuxinWidget_singleSwitch: "Single Switch",
  DeleteWidget_title: "Delete Widget",
  DeleteWidget_text: "Are you sure you want to delete this widget?",
  DeleteWidget_button: "Yes",
  DeleteWidget_button2: "No",
  Scenarios_addScenario: "Add Scene",
  Scenarios_noscenario: "No Scenes Found.",
  AddScenario_title1: "Customize Scene",
  AddScenario_text1: "Name",
  Scenario_namePlaceHolder: "Scene Name",
  AddScenario_button: "Save",
  AddScenario_alert1: "Please enter a name for this scene.",
  Scenarios_scenarioCommonName: "Scene",
  EditScenario_deleteButton: "Delete Scene",
  EditScenario_text5: "Hub",
  DeleteScenario_title: "Delete Scene",
  DeleteScenario_text: "Are you sure you want to delete this scene?",
  DeleteScenario_button: "Yes",
  DeleteScenario_button2: "No",
  EditWidget_title1: "Customize Widget",
  Name_text: "Name",
  WidgetName_PlaceHolder: "Widget Name",
  SaveChanges_button: "Save Changes",
  Output_text: "Output",
  ChooseHub_text: "Select Hub",
  ChooseOutput_text: "Select Output",
  WidgetName_alert: "Please enter widget name.",
  AddNewWidget_button: "Add",
  AddNewWidget_singleSwitchDescription: "A Single Switch to control on/off outputs with live feedback.",
  Save_button: "Save",
  TemperatureSensorSettings_title3: "Conditions",
  TemperatureSensorSettings_unknownScenario: "Unknown Scenario",
  TemperatureSensorSettings_title4: "Add Condition",
  TemperatureSensorSettings_rising: "Gets Higher",
  TemperatureSensorSettings_falling: "Gets Lower",
  TemperatureSensorSettings_text2: "Condition Type",
  TemperatureSensorSettings_text4: "Select Scenario",
  TemperatureSensorSettings_button2: "Add Condition",
  TemperatureSensorSettings_button3: "Save Conditions",
  TemperatureSensorSettings_button4: "Add Scenario",
  HubSettings_title4: "Database",
  HubSettings_button6: "Sync Database",
  HubSettings_button7: "Save Database",
  DeleteUser_serverError: "Server Error. Please try again later.",
  HubSettings_serverError: "Server Error. Please try again later.",
  HubSettings_noSnapshotsFound: "No Snapshots were found.",
  AddNewWidget_sceneButtonDescription: "A button to run your custom scene.",
  LuxinWidget_sceneButton: "Scene Button",
  SceneButton_runScene: "Run",
  AddSceneButtonWidget_button: "Save",
  EditSceneButtonWidget_button: "Save",
  DeleteDevice_alert: "You do not have access to this action.",
  Node2Settings_default5: "Same Toggle",
  Node2Settings_default6: "Cross Toggle",
  Node3Settings_default3: "Toggle",
  HubNetworkSettings_alert3: "Please enter network password.",
  AddNewDeviceUploadQR_alert2: "The photo does not contain a QR code.",
  AddNewDeviceUploadQR_alert3: "There was a problem scanning your QR code.",
  AddNode7_title: "IR Controller",
  AddNode7_text: "You've scanned an IR Controller. Hit next to add this device to your smart home.",
  AddNode7_button: "Next",
  NODE7_INPUT1_NAME: "Temperature",
  NODE7_INPUT2_NAME: "Humidity",
  Node7Settings_IrDevice: "IR Device",
  Node7Settings_addIrDevice: "Add IR Device",
  AddIrDevice_title1: "Customize",
  AddIrDevice_text1: "Name",
  AddIrDevice_namePlaceHolder: "IR Device Name",
  AddIrDevice_button: "Save",
  AddIrDevice_title2: "Select Device",
  AddIrDevice_text2: "Device Type",
  AddIrDevice_text3: "Brand",
  NODE7_AC_NAME: "Split",
  AddIrDevice_text4: "Model",
  AddIrDevice_testDevice: "Test Device",
  AddIrDevice_text5: "Please point your IR controller to your target device and select 'Test Device'. It your target device reacted, then hit 'Save', if not, try other models.",
  AddIrDevice_alert1: "Please enter device name",
  IrDeviceSettings_button2: "Delete IR Device",
  DeleteIrDevice_title: "Delete IR Device",
  DeleteIrDevice_text: "Are you sure you want to delete this IR device?",
  DeleteIrDevice_button: "Yes",
  DeleteIrDevice_button2: "No",
  IrDeviceSettings_title3: "Remote Controller",
  IrDeviceSettings_showRemote: "Show Remote Controller",
  AddIrDevice_turnDeviceOff: "Turn Off",
  DashBoard_scehdule: "Schedules",
  weekDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  weekDaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  AddSchedule_title1: "Customize",
  AddSchedule_text1: "Name",
  AddSchedule_namePlaceHolder: "Schedule Name",
  AddSchedule_text2: "Select Hub",
  AddSchedule_text3: "Hour",
  AddSchedule_text4: "Minute",
  AddSchedule_title2: "Time Select",
  AddSchedule_button: "Save",
  AddSchedule_text5: "Repeat",
  AddSchedule_title3: "Create Command",
  AddSchedule_button2: "Add Scene",
  AddSchedule_alert1: "Please enter a name for this schedule.",
  Schedules_schedule: "Schedule",
  Schedules_button: "Add Schedule",
  Schedules_loadError: "Problem loading schedules",
  Schedules_noSchedule: "No Schedules were found",
  Schedules_time: "Time: ",
  Schedules_repeat: "Repeat: ",
  AddScheduleSuccess_title: "Success",
  AddScheduleSuccess_text: "Your schedule has successfully been added to system.",
  AddScheduleSuccess_button: "Finish",
  Schedules_todayOnly: "Today Only",
  DeleteSchedule_title: "Delete Schedule",
  DeleteSchedule_text: "Are you sure you want to delete this schedule?",
  DeleteSchedule_button: "Yes",
  DeleteSchedule_button2: "No",
  Schedules_alert: "You have no hubs installed.",
  RelaySSR2ASettings_switchState_Unknown: "Loading...",
  CommandCreator_title2: "Commands",
  CommandCreator_title3: "Create Command",
  CommandCreator_text2: "Output",
  CommandCreator_text3: "Output State",
  CommandCreator_text4: "Delay (seconds)",
  CommandCreator_outputStateOn: "ON",
  CommandCreator_outputStateOff: "OFF",
  CommandCreator_outputStateToggle: "Toggle",
  CommandCreator_button2: "Add Command",
  CommandCreator_outputStateTitle: "State",
  CommandCreator_delayTitle: "Delay",
  CommandCreator_delaySecond: "Second(s)",
  CommandCreator_alert2: "Please create at least one command.",
  CommandCreator_text5: "Select Hub",
  CommandCreator_alertNoOutputs: "No outputs found for the selected Hub",
  NoOutPutForHub_alert: "No outputs found for the selected Hub",
  NoInstalledHub_alert: "You don't have any installed Hubs.",
  CommandCreator_alertNoHubs: "You don't have any installed Hubs.",
  CommandCreator_alertPacketOverflow: "Your command length exceeds the limit.",
  CommandCreator_button3: "Create Command",
  AddTemperatureAutomationWidget_title1: "Customize Widget",
  AddTemperatureAutomationWidget_text1: "Name",
  AddTemperatureAutomationWidget_namePlaceHolder: "Widget Name",
  AddTemperatureAutomationWidget_title2: "Automation Settings",
  AddTemperatureAutomationWidget_automationType1: "Heat and Cool",
  AddTemperatureAutomationWidget_automationType2: "Cool",
  AddTemperatureAutomationWidget_automationType3: "Heat",
  AddTemperatureAutomationWidget_text2: "Automation Type",
  AddTemperatureAutomationWidget_text3: "Season select",
  AddTemperatureAutomationWidget_targetSeason1: "Summer",
  AddTemperatureAutomationWidget_targetSeason2: "Winter",
  AddTemperatureAutomationWidget_text4: "Temperature Sensor Select",
  AddTemperatureAutomationWidget_text5: "Select Hub",
  AddTemperatureAutomationWidget_cool_on_description: "Please create the command to turn your cooling system on",
  AddTemperatureAutomationWidget_cool_off_description: "Please create the command to turn your cooling system off",
  AddTemperatureAutomationWidget_heat_on_description: "Please create the command to turn your heating system on",
  AddTemperatureAutomationWidget_heat_off_description: "Please create the command to turn your heating system off",
  AddTemperatureAutomationWidget_cool_text: "Cooling Output",
  AddTemperatureAutomationWidget_heat_text: "Heating Output",
  AddTemperatureAutomationWidget_button: "Save",
  AddTemperatureAutomationWidget_alertNoSensor: "No temperature sensor found in your selected hub.",
  AddTemperatureAutomationWidget_alertCoolOnNoCommand: "Please create the command to turn your cooling system on",
  AddTemperatureAutomationWidget_alertCoolOffNoCommand: "Please create the command to turn your cooling system off",
  AddTemperatureAutomationWidget_alertHeatOnNoCommand: "Please create the command to turn your heating system on",
  AddTemperatureAutomationWidget_alertHeatOffNoCommand: "Please create the command to turn your heating system off",
  AddTemperatureAutomationWidget_alertHubFailed: "Error connecting to target Hub. Please make sure you are connected to target Hub.",
  AddTemperatureAutomationWidget_alertSensorFailed: "Error connecting to temperature sensor. Your automation is added but please make sure your temperature sensor is turned on.",
  LuxinWidget_temperatureAutomation: "Temperature Automation",
  TemperatureAutomationWidget_alertSensorFailed: "Operation was successful but please make sure your temperature sensor is turned on.",
  EditSingleSwitchWidget_alertNotSync: "Could not load commands because your app is not synced. Please sync your database.",
  AddNewWidget_temperatureAutomationDescription: "Full control over cooling and heating systems",
  AddTemperatureAutomationWidget_alertNotOwner: "Sorry, Only Hub's owner can set automations.",
  EditTemperatureAutomationWidget_alertNotOwner: "Sorry, Only Hub's owner can edit automations.",
  DeleteTemperatureAutomation_title: "Delete Temperature Automation",
  DeleteTemperatureAutomation_text: "Are you sure you want to delete this automation? After deleting, this automation will no longer function.",
  DeleteTemperatureAutomation_button: "Yes",
  DeleteTemperatureAutomation_button2: "No",
  DeleteTemperatureAutomation_alertNotOwner: "Sorry, Only Hub's owner can delete automations.",
  DeleteTemperatureAutomation_alertDeleteError: "Oops, something went wrong.",
  DeleteTemperatureAutomation_alertSensorFailed: "Error connecting to your temperature sensor. Your automation is deleted but please make sure your temperature sensor is turned on.",
  HubNetworkSettings_alert4: "Password should be at lesat 8 characters.",
  Schedules_commands: "Commands: ",
  Schedules_showCommands: "Show Comamnds",
  AddSchedule_alert5: "You should create a command for this schedule.",
  AddSchedule_alert6: "You cannot add more schedules.",
  DeleteSchedule_alertDeleteError: "Oops, something went wrong.",
  Schedules_everyDay: "Everyday",
  AddSchedule_text6: "Next Occurrence",
  AddSchedule_button3: "Delete",
  AddNode9_title: "RGBW Controller",
  AddNode9_text: "You've scanned an RGBW Controller. Hit next to add this device to your smart home.",
  AddNode9_button: "Next",
  NODE9_INPUT1_NAME: "Input 1",
  NODE9_OUTPUT1_NAME: "RGB",
  NODE9_OUTPUT2_NAME: "Red",
  NODE9_OUTPUT3_NAME: "Green",
  NODE9_OUTPUT4_NAME: "Blue",
  NODE9_OUTPUT5_NAME: "White",
  Node9Settings_hue: "HUE",
  Node9Settings_rgbw: "RGBW",
  Node9Settings_rgb: "RGB",
  Node9Settings_red: "Red",
  Node9Settings_green: "Green",
  Node9Settings_blue: "Blue",
  Node9Settings_white: "White",
  Node9Settings_alert1: "Connection Error!",
  Node9Settings_fadeTime: "Fade Time (ms)",
  Node9Settings_animation: "Animation",
  Node9Settings_animation0: "Disabled",
  Node9Settings_animation1: "Random",
  Node9Settings_animation2: "HUE Circle",
  Node9Settings_default: "Default Color",
  Node2Settings_setAsDefault: "Set as default color",
  Node9Settings_colorPickerType: "Color Palette",
  LuxinWidget_RGBW: "RGBW Controller",
  AddNewWidget_rgbwDescription: "A Color Palette to control your RGBW strip.",
  AddRGBWWidget_button: "Save",
  HubSettings_title5: "Voice Assistant",
  HubSettings_button8: "Amazon Alexa",
  NODE7_TV_NAME: "Television",
  AddSchedule_text7: "Schedule Type",
  AddSchedule_text8: "Output Control",
  AddSchedule_text9: "Automation Control",
  CommandCreator_text10: "Automation",
  CommandCreator_text11: "State",
  CommandCreator_alertDuplicateAutomation: "This Automation is already chosen.",
  LoginRegister_googleLoginFailed: "Error connecting to google servers",
  AddNode8_title: "IR/RF Controller",
  AddNode8_text: "You've scanned an IR/RF Controller. Hit next to add this device to your smart home.",
  AddNode8_button: "Next",
  HubSettings_button9: "Google Nest",
  AddNest_Success: "Your connection to Google Voice Assistant has been established.",
  AddAlexa_Success: "Your connection to Amazon Alexa Voice Assistant has been established.",
  SelectAddNewUserType_title: "Add New User",
  SelectAddNewUserType_button1: "Via Mobile",
  SelectAddNewUserType_button2: "Via Google Account",
  AddNewUserGoogle_text: "To add the new user, please enter google account and name of the new user.",
  AddNewUserGoogle_placeHolder: "Google Account",
  AddNewUserGoogle_alert1: "Please enter google account of new user.",
  AddNewUserGoogle_serverResponseFail: "Request failed. Please check google account and try again.",
  Node8Settings_Devices: "Devices",
  Node8Settings_addRfDevice: "Add RF Device",
  AddRfDevice_title1: "Customize",
  AddRfDevice_text1: "Name",
  AddRfDevice_namePlaceHolder: "RF Device Name",
  AddRfDevice_button: "Save",
  AddRfDevice_title2: "Select Device",
  AddRfDevice_text2: "Device Type",
  AddRfDevice_testDevice: "Pair Device",
  AddRfDevice_text3: "Please put your target device on 'Learning Mode' and press 'Pair'",
  AddRfDevice_text4: "If pairing was successful, test your device with following buttons, if not, choose another device type.",
  AddRfDevice_alert1: "Please enter device name",
  AddRfDevice_testChannel1: "Test Channel 1",
  AddRfDevice_testChannel2: "Test Channel 2",
  AddRfDevice_testChannel3: "Test Channel 3",
  AddRfDevice_testChannel4: "Test Channel 4",
  RfDeviceSettings_button2: "Delete RF Device",
  DeleteRfDevice_title: "Delete RF Device",
  DeleteRfDevice_text: "Are you sure you want to delete this RF device?",
  DeleteRfDevice_button: "Yes",
  DeleteRfDevice_button2: "No",
  AddSmartCurtainWidget_title1: "Customize Widget",
  AddSmartCurtainWidget_text1: "Name",
  AddSmartCurtainWidget_namePlaceHolder: "Widget Name",
  AddSmartCurtainWidget_title2: "Widget Settings",
  AddSmartCurtainWidget_curtainType1: "Top Down",
  AddSmartCurtainWidget_curtainType2: "Left Right",
  AddSmartCurtainWidget_text2: "Curtain Type",
  AddSmartCurtainWidget_text3: "Select Hub",
  AddSmartCurtainWidget_commands: "Commands",
  AddSmartCurtainWidget_up_description: "Please create the command to move the curtain up",
  AddSmartCurtainWidget_stop_description: "Please create the command to stop the curtain",
  AddSmartCurtainWidget_down_description: "Please create the command to move the curtain down",
  AddSmartCurtainWidget_left_description: "Please create the command to move the curtain left",
  AddSmartCurtainWidget_right_description: "Please create the command to move the curtain right",
  CommandCreator_textTargetRfCommand: "Select Channel",
  CommandCreator_channel: "Channel",
  CommandCreator_selectedChannel: "Selected Channel",
  AddSmartCurtainWidget_alertCurtainUpNoCommand: "Please create the command to move the curtain up",
  AddSmartCurtainWidget_alertCurtainDownNoCommand: "Please create the command to move the curtain down",
  AddSmartCurtainWidget_alertCurtainLeftNoCommand: "Please create the command to move the curtain left",
  AddSmartCurtainWidget_alertCurtainRightNoCommand: "Please create the command to move the curtain right",
  AddSmartCurtainWidget_alertCurtainStopNoCommand: "Please create the command to stop the curtain",
  AddSmartCurtainWidget_button: "Save",
  LuxinWidget_SmartCurtain: "Smart Curtain",
  AddNewWidget_smartCurtainDescription: "To Control up-down and left-right smart curtains.",
  RfDeviceSettings_title1: "Device",
  AddDoubleSwitchWidget_text1: "Select Output 1",
  AddDoubleSwitchWidget_text2: "Select Output 2",
  AddDoubleSwitchWidget_title1: "Output 1",
  AddDoubleSwitchWidget_title2: "Output 2",
  LuxinWidget_doubleSwitch: "Double Switch",
  AddNewWidget_doubleSwitchDescription: "Two Switches to control two on/off outputs with live feedback.",
  AddAcRemoteWidget_title1: "Remote",
  LuxinWidget_acRemote: "AC Remote",
  AddNewWidget_acRemoteDescription: "A full remote controller to control your ac unit with lcd",
  AddAcRemoteWidget_text1: "Select Remote Controller",
  AddTemperatureWidget_title1: "Temperature Sensor",
  AddTemperatureWidget_text1: "Select Temperature Sensor",
  LuxinWidget_temperatureWidget: "Temperature Sensor",
  TemperatureWidget_alert1: "Sensor is offline",
  AddNewWidget_temperatureWidgetDescription: "A widget to show value of temperature sensor",
  AddNode11_title: "Smart Plug",
  AddNode11_text: "You've scanned a Luxin Smart Plug. Hit next to add this device to your smart home.",
  AddNode11_button: "Next",
  Node11Settings_hue: "LED State (HSV)",
  Node11Settings_rgb: "LED State (RGB)",
  Node11Settings_default: "LED Settings",
  Node11Settings_setAsOnColor: "Set as LED On Color",
  Node11Settings_setAsOffColor: "Set as LED Off Color",
  RelaySSR2ASettings_initState6: "Last State",
  AddNode10_title: "RGB 220V Driver",
  AddNode10_text: "You've scanned an RGB 220V Driver. Hit next to add this device to your smart home.",
  AddNode10_button: "Next",
  Node10Settings_rgb: "RGB",
  Node10Settings_outputPower: "Output Power",
  Node2Settings_powerOutputDesc: "You can adjust output power with this setting. Make sure to set this number on 70% or less when using strips longer than 30 meters.",
  Node10Settings_rgbOrder: "Color Order",
  Node2Settings_colorOrderDesc: "Some strips have different Red, Green & Blue order. You can adjust color order with this setting.",
  Node10Settings_rgbOrder1: "R-G-B",
  Node10Settings_rgbOrder2: "R-B-G",
  Node10Settings_rgbOrder3: "G-R-B",
  Node10Settings_rgbOrder4: "G-B-R",
  Node10Settings_rgbOrder5: "B-R-G",
  Node10Settings_rgbOrder6: "B-G-R",
  AddRGBStandAlone_title: "Add WiFi RGB Controller",
  AddRGBStandAlone_text: "This is a 'Luxin WiFi RGB Controller'. To continue, hit 'Next'",
  AddRGBStandAlone_button: "Next",
  AddRGBStandAloneTurnOn_title: "Turn it ON",
  AddRGBStandAloneTurnOn_text: "Plug it to a power source and turn it ON.",
  AddRGBStandAloneTurnOn_button: "Next",
  AddStandAloneLedCheck_title: "Device's LED Status",
  AddStandAloneLedCheck_text: "Is the Device's LED off?",
  AddStandAloneLedCheck_button: "Yes",
  AddStandAloneLedCheck_button2: "No",
  AddRGBStandAloneLedError_title: "Oops!",
  AddRGBStandAloneLedError_text: "This Device already has an ADMIN. Ask the admin to add you as a USER. Or you can reset this Device as a new one.",
  AddRGBStandAloneLedError_button: "Reset Device",
  AddRGBStandAloneReset_title: "Reset Device",
  AddRGBStandAloneReset_text: "Push the reset button on the side marked as Factory Reset for 5 seconds.To change the ADMIN, hold the button till Device's LED blinks Blue and release.",
  AddRGBStandAloneReset_button: "Next",
  AddRGBStandAloneSecurity_title: "Security Options",
  AddRGBStandAloneSecurity_text: "You can use Two-Factor authentication by setting a password on your Device to have maximum security.",
  AddRGBStandAloneSecurity_button: "Choose Password",
  AddRGBStandAloneSetPassword_title: "Two-Factor Auth.",
  AddRGBStandAloneSetPassword_text: "This is not your account password. It's this Device's password!. Try your best not to forget this password.",
  AddRGBStandAloneSetPassword_button: "Next",
  AddRGBStandAloneSetPassword_placeHolder: "Password",
  AddRGBStandAloneSetPassword_placeHolder2: "Confirm Password",
  AddRGBStandAloneSetPassword_alert_passwordEmpty: "Please enter a password!",
  AddRGBStandAloneSetPassword_alert_passwordNotMatch: "Password confirmation doesn't match password!",
  AddRGBStandAloneNameColor_title: "Customize Device",
  AddRGBStandAloneNameColor_text: "Please select a name and a color for your Device.",
  AddRGBStandAloneNameColor_placeHolder: "Name (Home, Office, ...)",
  AddRGBStandAloneNameColor_button: "Next",
  AddRGBStandAloneNameColor_alert_nameEmpty: "Please enter a name for your Device",
  AddRGBStandAloneConnectWifi_title: "Connect to Device",
  AddRGBStandAloneConnectWifi_text: "Please go to your phone's Wi-Fi settings and connect to the following network. Then return to this App and select 'Connect to Device'.",
  AddRGBStandAloneConnectWifi_button: "Connect to Device",
  AddRGBStandAloneNotFound_title: "Hub Connection Error!",
  AddRGBStandAloneNotFound_text: "Unfortunately there was a problem connecting to your Hub. Please make sure that you are connected to Hub's Wi-Fi network and then try again.",
  AddRGBStandAloneNotFound_button: "Try Again",
  AddRGBStandAloneNotFound_Cancel: "Cancel",
  AddRGBStandAloneSuccess_title: "Success",
  AddRGBStandAloneSuccess_text: "Your Luxin Deivce has successfully been added to your app. You can view and edit your Device's settings in 'Devices' tab.",
  AddRGBStandAloneSuccess_button: "Finish",
  Node9Settings_animation3: "Microphone HSV",
  Node9Settings_animation4: "Microphone Brightness",
  Node9Settings_animation5: "Audio Jack HSV",
  Node9Settings_animation6: "Audio Jack Brightness",
  Node2Settings_animationTypeDesc: "If animation type is set to Microphone, in order to reduce WiFi noise on voice quality, Device's WiFi is turned off untill the next power up.",
  LuxinWidget_tvRemote: "TV Remote",
  AddTvRemoteWidget_text1: "Remote Style",
  AddTvRemoteWidget_remoteStyle1: "Sound & Channel",
  AddTvRemoteWidget_remoteStyle2: "Source & Menu",
  AddNewWidget_tvRemoteDescription: "A remote controller to control your TV with multiple styles",
  Node2Settings_default7: "Disabled",
  Node2Settings_default8: "Adjusting Presence Timer",
  OpenClose_text: "Normally Open / Normally Closed",
  NormalyOpen_text: "Normally Open",
  NormalyClosed_text: "Normally Closed",
  Folder_text: "Folder",
  Root_text: "Root",
  LuxinWidget_folder: "Folder",
  AddNewWidget_folderDescription: "A Folder to hold other widgets.",
  AlertHubFailed: "Error connecting to target Hub. Please make sure you are connected to target Hub.",
  AlertOperationFailed: "Oops, something went wrong.",
  AddNotificationWidget_alertSensorFailed: "Error connecting to switch. Your notification is added but please make sure your switch is turned on.",
};
